import { LuTrash2, LuPencil } from 'react-icons/lu';
import { Button } from '@/components/ui/button.tsx';
import { useTranslation } from 'react-i18next';

export default function ScreenshotOverlayCard({
  screenshot,
  onRemove,
  onEdit,
}: {
  screenshot: string;
  onRemove: () => void;
  onEdit?: () => void;
}) {
  const { t } = useTranslation();

  return (
    <div className="relative w-full rounded-lg overflow-hidden border border-gray-300 shadow-sm group">
      {/* Screenshot with slight dark overlay */}
      <img
        src={screenshot}
        alt={t('feedback.screenshot.alt', 'Screenshot')}
        className="w-full h-auto object-contain brightness-90 grayscale-[15%] pointer-events-none"
      />

      {/* Delete button (top-right) */}
      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
        className="absolute top-2 right-2 z-10 rounded-full bg-white/90 hover:bg-red-100 text-red-600 hover:text-red-700 shadow active:scale-95 transition-all pointer-events-auto"
        aria-label={t('feedback.screenshot.delete', 'Delete screenshot')}
      >
        <LuTrash2 className="w-5 h-5" />
      </Button>

      {/* Edit button centered */}
      {onEdit && (
        <div className="absolute inset-0 flex items-center justify-center">
          <Button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onEdit();
            }}
            className="rounded-md px-4 py-2 bg-white/90 hover:bg-muted text-indigo-700 border border-indigo-300 active:scale-95 transition-all shadow backdrop-blur-sm"
          >
            <LuPencil className="mr-2 h-4 w-4" />
            {t('feedback.screenshot.edit', 'Highlight or Hide Info')}
          </Button>
        </div>
      )}
    </div>
  );
}
